/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} New_Project_Advanced_Options_Aria_LabelInputs */

const en_new_project_advanced_options_aria_label = /** @type {(inputs: New_Project_Advanced_Options_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Advanced Options`)
};

const fr_new_project_advanced_options_aria_label = /** @type {(inputs: New_Project_Advanced_Options_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Options avancees`)
};

const de_new_project_advanced_options_aria_label = /** @type {(inputs: New_Project_Advanced_Options_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Erweiterte Optionen`)
};

const it_new_project_advanced_options_aria_label = /** @type {(inputs: New_Project_Advanced_Options_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Opzioni avanzate`)
};

const ru_new_project_advanced_options_aria_label = /** @type {(inputs: New_Project_Advanced_Options_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Расширенные параметры`)
};

const es_new_project_advanced_options_aria_label = /** @type {(inputs: New_Project_Advanced_Options_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Opciones avanzadas`)
};

const zh_cn2_new_project_advanced_options_aria_label = /** @type {(inputs: New_Project_Advanced_Options_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`高级选项`)
};

const ja_new_project_advanced_options_aria_label = /** @type {(inputs: New_Project_Advanced_Options_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`詳細オプション`)
};

const hi_new_project_advanced_options_aria_label = /** @type {(inputs: New_Project_Advanced_Options_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`उन्नत विकल्प`)
};

const pt_pt2_new_project_advanced_options_aria_label = /** @type {(inputs: New_Project_Advanced_Options_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Opções avançadas`)
};

/**
* | output |
* | --- |
* | "Advanced Options" |
*
* @param {New_Project_Advanced_Options_Aria_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const new_project_advanced_options_aria_label = /** @type {((inputs?: New_Project_Advanced_Options_Aria_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<New_Project_Advanced_Options_Aria_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_new_project_advanced_options_aria_label(inputs)
	if (locale === "de") return de_new_project_advanced_options_aria_label(inputs)
	if (locale === "it") return it_new_project_advanced_options_aria_label(inputs)
	if (locale === "ru") return ru_new_project_advanced_options_aria_label(inputs)
	if (locale === "es") return es_new_project_advanced_options_aria_label(inputs)
	if (locale === "zh-CN") return zh_cn2_new_project_advanced_options_aria_label(inputs)
	if (locale === "ja") return ja_new_project_advanced_options_aria_label(inputs)
	if (locale === "hi") return hi_new_project_advanced_options_aria_label(inputs)
	if (locale === "pt-PT") return pt_pt2_new_project_advanced_options_aria_label(inputs)
	return en_new_project_advanced_options_aria_label(inputs)
});